import styles from "./upgrade_banner.module.scss"

interface Props {
  onClick: () => void
  content: string
}

const UpgradeBanner = ({ onClick, content }: Props) => (
  <a onClick={onClick} className={styles["upgrade-banner"]}>
    {content} <span className={styles.cta}>You need to upgrade to enable this Applet.</span>
  </a>
)

export default UpgradeBanner
